import React from 'react';
import { func,array,bool } from 'prop-types';
import DragAndDropEventHandler from './DragAndDropEventHandler';
import QuizListItem from '../QuizListItem/index';
import DraggableItem from '../../atoms/DraggableItem/index';

const DraggableQuizItemComponent = DraggableItem(QuizListItem);


const QuizItemList = ({values, indexed, onSort, onClick, onDelete, onCheck})=>{
	const lists = <DragAndDropEventHandler 
		key={values}
		values={values}
		onSort={onSort}
		render={({
			value,
			index,
			...props})=>{
			return (<DraggableQuizItemComponent 
				{...props}
				index={index+1}
				indexed={indexed}
				checked={value.checked}
				isSample={value.isSample}
				onCheck={(checked)=>{onCheck&&onCheck(checked,index);}}
				key={value.id} 
				options={value.options}
				content={value.question}
				onClick={()=>onClick&&onClick(index)} 
				onDelete={()=>{onDelete&&onDelete(index);}}
			/>);
		}}
	/>;
	return lists;
};

QuizItemList.propTypes = {
	values : array,
	onSort : func,
	isSample : bool,
	onClick : func.isRequired,
	onCheck : func.isRequired,
	onDelete : func.isRequired
};

export default QuizItemList;